import axios from 'axios';
import React, { useEffect, useState } from 'react'
import Select from 'react-select';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export default function AttendanceReport() {

    const API_URL = process.env.REACT_APP_API_URL;
    const [msg, setMsg] = useState('')
    const [errormsg, setError] = useState('')



 pdfMake.vfs = pdfFonts.vfs;



    const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%',
        float:'right'
    }



    const [datechosenfrom, setdatechosenfrom] = useState()
    const [datechosento, setdatechosento] = useState()
    const [data, setData] = useState(null);
const [search, setsearch] = useState(false)
    async function getDetails() {
        setsearch(true)
        try {
            const url = `${API_URL}shypvdriverapp/driver-attendance/all`;

            const response = await axios.get(url, {
                params: {

                    dateFrom: datechosenfrom,
                    dateTo: datechosento,
                },
            });

            if (response.data.success) {
                setData(response.data.data.content);
            }

            console.log("Response:", response.data);
        } catch (error) {
            console.error("Error fetching attendance data:", error);
        }
    }



    function downloadPDF() {
    if (!data || data.length === 0) {
      alert("No data available to download");
      return;
    }

   const safe = (val) => (val !== undefined && val !== null ? String(val) : "-");

const tableBody = [
  [
    { text: "ID", bold: true },
    { text: "Driver", bold: true },
    { text: "Check-In Time", bold: true },
    { text: "Check-In Location", bold: true },
    { text: "Check-Out Time", bold: true },
    { text: "Check-Out Location", bold: true },
    { text: "Status", bold: true },
  ],
  ...data.map((item,i) => [
    safe(i+1),
    safe(item.driver.name),
    safe(new Date(item.checkInTime).toLocaleString()),

    // ✅ Check-In location with warehouse name + coordinates
    safe(
      item.checkInWarehouse
        ? `${item.checkInWarehouse.name}\n${item.checkInLocation || ""}`
        : item.checkInLocation
    ),

    // ✅ Check-Out Time (may be null)
    safe(item.checkOutTime ? new Date(item.checkOutTime).toLocaleString() : "-"),

    // ✅ Check-Out location with null checks
    safe(
      item.checkOutWarehouse
        ? `${item.checkOutWarehouse.name}\n${item.checkOutLocation || ""}`
        : item.checkOutLocation
    ),

    safe(item.status),
  ]),
];



    const docDefinition = {
      content: [
        { text: "Driver Attendance Report", style: "header" },
        { text: `From: ${datechosenfrom}  To: ${datechosento}`, margin: [0, 0, 0, 10] },
        {
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "*", "*", "*", "*", "auto"],
            body: tableBody,
          },
          layout: "lightHorizontalLines",
        },
      ],
      styles: {
        header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
      },
      pageOrientation: "landscape",
    };

    pdfMake.createPdf(docDefinition).download("driver_attendance.pdf");
  }

    return (
        <div>

            <div className="form-container">
                <div className="row">
                    <div className="col-md-6">
                        <h5 style={{ float: 'left' }}>Attendance Report </h5>
                    </div>

                </div>
                <div className="row">

                    <div className="col-md-8">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="driver">From Date:</label>
                                    <input type="date"
                                        id="date"
                                        value={datechosenfrom}
                                        onChange={(e) => setdatechosenfrom(e.target.value)}

                                    />


                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="driver">To Date:</label>
                                    <input type="date"
                                        id="date"
                                        value={datechosento}
                                        onChange={(e) => setdatechosento(e.target.value)}

                                    />


                                </div>
                            </div>


                        </div>


                        {/* Driver Selection */}


                        <div className="row">
                           
                            <div className="col-md-6">
                                <a onClick={getDetails} style={buttonsyle} type="button" className="btn-demo add">
                                    Submit
                                </a>

                    

                            </div>
                        </div>
                        <p style={{ color: 'red', marginTop: '2%' }}>{errormsg}</p>
                    </div>
                </div>


<div className="row">
    <div className="col-md-11" style={{ overflowX: "auto" }}>
 {data && data.length > 0 ? (
    <>
    <div className="col-md-12" style={{marginBottom:'2%'}}>
   <a  style={buttonsyle} onClick={downloadPDF} >
          Download PDF
        </a>
    </div>
              
        <table
          border="1"
          cellPadding="8"
          style={{ borderCollapse: "collapse", width: "100%" }}
        >
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th>ID</th>
              <th>Driver</th>
              <th>Check-In Time</th>
              <th>Check-In Location</th>
              <th>Check-Out Time</th>
              <th>Check-Out Location</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, i) => (
              <tr key={item.id}>
                <td>{i +1}</td>
                <td>{item.driver.id} - {item.driver.name}</td>
                <td>{new Date(item.checkInTime).toLocaleString()}</td>
                <td>{item.checkInWarehouse.name}
                    <br />{item.checkInLocation}</td>
                <td>
                  {item.checkOutTime
                    ? new Date(item.checkOutTime).toLocaleString()
                    : "-"}
                </td>
                <td>{item.checkOutWarehouse && item.checkOutWarehouse.name} <br />{item.checkOutLocation || "-"}</td>
                <td>{item.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </>

      ) : search && 'No records found'}
    </div>
</div>






            </div>
        </div>
    )
}
